export default __webpack_public_path__ + "static/media/Mantarays.1b0ca467.svg";